module.exports = __webpack_public_path__ + "img/constructn_estates.f996994b.png";